export default "__VITE_ASSET__vAVIHMPz__"